import Vue from 'vue'
import VueRouter from 'vue-router'
import { Route, RouteGroup } from '@billow/easy-route'
import { concat } from 'lodash'

Vue.use(VueRouter)

const routes = concat(
  
  // Guest Routes
  RouteGroup({
    
    middleware: ['guest'],

    routes: [
      Route('/login', 'login', () => import('@/views/auth/Login')),
    ]
  }),

  // Auth Routes
  RouteGroup({
    
    middleware: ['auth'],

    routes: [
      Route('/', 'dashboard', () => import('@/views/Dashboard')),
      Route('/scraper', 'create-scraper', () => import('@/views/scrapers/Create.vue')),
      // Vulnerabilities
      Route('/vulnerabilities', 'vulnerabilities', () => import('@/views/vulnerability/Index')),
      Route('/vulnerability', 'new-vulnerability', () => import('@/views/vulnerability/Create')),

      RouteGroup({
        parent: Route('/vulnerability/:vulnerability', '', () => import('@/views/vulnerability/manager/Manager.vue')),
        routes: [
          Route('/', 'vulnerability-manager', () => import('@/views/vulnerability/manager/Overview.vue')),
          Route('edit', 'vulnerability-edit', () => import('@/views/vulnerability/Edit.vue')),
          Route('versions', 'vulnerability-versions', () => import('@/views/vulnerability/manager/Versions.vue')),
          Route('distributions', 'vulnerability-distributions', () => import('@/views/vulnerability/manager/Distributions.vue')),
        ]
      }),

      // CWEs
      Route('/cwes', 'cwes', () => import('@/views/cwe/Index')),
      Route('/cwe/:cwe', 'edit-cwe', () => import('@/views/cwe/Edit')),

      // Products
      Route('/software', 'software', () => import('@/views/software/Index')),
      Route('/software/create', 'new-software', () => import('@/views/software/Create')),
      
      RouteGroup({
        parent: Route('/software/:software', '', () => import('@/views/software/Manager/Manager')),
        routes: [
          Route('/', 'software-manager', () => import('@/views/software/Manager/Overview')),
          Route('distributions', 'software-distributions', () => import('@/views/software/Manager/Distributions')),
          Route('edit', 'software-edit', () => import('@/views/software/Edit')),
          Route('versions', 'software-versions', () => import('@/views/software/Manager/Versions')),
          Route('versions/:version/vulnerabilities', 'version-vulnerabilities', () => import('@/views/software/Manager/VersionVulnerabilities')),
          Route('vulnerabilities', 'software-vulnerabilities', () => import('@/views/software/Manager/Vulnerabilities')),
        ]
      }),

      // Standards
      Route('/standards', 'standards', () => import('@/views/standard/Index')),
      Route('/checkpoints', 'checkpoints', () => import('@/views/standard/Checkpoints')),
      Route('/checkpoint', 'create-checkpoint', () => import('@/views/standard/CreateCheckpoint')),
      Route('/standard', 'new-standard', () => import('@/views/standard/Create')),
      RouteGroup({
        parent: Route('/standards/:standard', '', () => import('@/views/standard/Manager/Manager')),
        routes: [
          Route('/', 'standard-manager', () => import('@/views/standard/Manager/Overview')),
          Route('edit', 'edit-standard', () => import('@/views/standard/Manager/Edit')),
          Route('sections', 'standard-sections', () => import('@/views/standard/Manager/Sections')),
          Route('section', 'new-standard-section', () => import('@/views/standard/Manager/CreateSection')),
          RouteGroup({
            parent: Route('sections/:section', '', () => import('@/views/standard/Section/Manager')),
            routes: [
              Route('/', 'section-manager', () => import('@/views/standard/Section/Checkpoints')),
              Route('edit', 'edit-section', () => import('@/views/standard/Section/Edit')),
            ]
          })
        ]
      }),

      // Checkpoints
      RouteGroup({

        parent: Route('/checkpoint/:checkpoint', '', () => import('@/views/standard/Checkpoint/Manager')),

        routes: [
          Route('/', 'checkpoint-manager', () => import('@/views/standard/Checkpoint/Standards')),
          Route('assessor', 'checkpoint-assessor', () => import('@/views/standard/Checkpoint/Assessor')),
          Route('edit', 'checkpoint-edit', () => import('@/views/standard/Checkpoint/Edit')),
        ]

      }),

      // App Metas
      Route('/attribute-types', 'attribute-types', () => import('@/views/attribute-type/Index')),
      Route('/attribute-type', 'create-attribute-type', () => import('@/views/attribute-type/Create')),

      RouteGroup({
        parent: Route('/attribute-type/:attributeType', '', () => import('@/views/attribute-type/Manager/Manager')),
        routes: [
          Route('/', 'attribute-type-manager', () => import('@/views/attribute-type/Manager/Overview')),
          Route('scrapers', 'attribute-type-scrapers', () => import('@/views/attribute-type/Manager/Scrapers')),
          Route('scrapers/:scraper/secondary-scrapers', 'attribute-type-scraper-secondary-scrapers', () => import('@/views/attribute-type/secondary-scrapers/SecondaryScrapers')),
          Route('scrapers/:scraper/secondary-scraper', 'attribute-type-scraper-create-secondary-scraper', () => import('@/views/attribute-type/secondary-scrapers/CreateSecondaryScraper')),
          Route('secondary-scraper', 'attribute-type-create-secondary-scraper', () => import('@/views/attribute-type/Manager/AddSecondaryScraper')),
          Route('assessors', 'attribute-type-assessors', () => import('@/views/attribute-type/Manager/Assessors.vue')),
          Route('edit', 'attribute-type-edit', () => import('@/views/attribute-type/Edit')),
        ]
      }),

      Route('/scrapers', 'scrapers', () => import('@/views/scrapers/Index.vue')),
      Route('/scrapers/:scraper', 'edit-scraper', () => import('@/views/scrapers/Edit.vue')),
      Route('/secondary-scrapers/:secondaryScraper/source', 'edit-secondary-source-scraper', () => import('@/views/scrapers/EditSecondarySourceScraper.vue')),
    ]
  }),

)

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-active',
  base: process.env.BASE_URL,
  routes
})

export default router
